import {
  serializeHtml,
  createPlateUIEditor,
  isText,
} from '@udecode/plate';

import { serializedPlugins } from '../contexts/fullEditor';

// #TODO: This needs to be refined for serializing other custom components.
// e.g. checkboxes, images, etc.
const serializeAsHtml = (data) => {
  const editor = createPlateUIEditor({
    plugins: serializedPlugins,
  });

  // To match spacing between editor and rendered output.
  const nodes = convertEmptyLeavesToSpace(data);
  editor.children = nodes;

  return serializeHtml(
    editor,
    {
      nodes,
      convertNewLinesToHtmlBr: true,
      preserveClassNames: ['slate'],
    },
  );
};

// This is needed to render the same spacing within the editor.
const convertEmptyLeavesToSpace = (nodes) => {
  return nodes.map(node => {
    if (isText(node)) {
      // Replace '' with non-breaking space so rendered element will retain height.
      // Remove any kind of marks from an empty leaf also.
      if (node.text === '' && nodes.length === 1) return { text: '\u00A0' };
      // Just return the node if it has text in the leaf.
      return node;
    }
    // Recursively iterate through children.
    return { ...node, children: convertEmptyLeavesToSpace(node.children) };
  });
};

export default serializeAsHtml;
